/**
 * Shop The Look bundle: update total when complementary variant changes,
 * add both items (current + complementary) to cart on button click.
 */
(function () {
  function init() {
    const theme = window.theme;
    if (!theme || !theme.routes || !theme.routes.cartAdd) return;

    document.querySelectorAll('[data-shop-the-look-bundle]').forEach(function (bundleEl) {
      const sectionId = bundleEl.dataset.sectionId;
      const formId = bundleEl.dataset.productFormId;
      const form = document.getElementById(formId) || bundleEl.closest('product-form')?.querySelector('.js-product-form');
      const currentSelect = bundleEl.querySelector('[data-current-variant-select]');
      const select = bundleEl.querySelector('[data-complementary-variant-select]');
      const totalEl = bundleEl.querySelector('[data-bundle-total]');
      const compPriceEl = bundleEl.querySelector('[data-complementary-price]');
      const btn = bundleEl.querySelector('[data-shop-the-look-add]');
      const pricesScript = bundleEl.querySelector('[data-bundle-prices]');

      if (!form || !select || !totalEl || !btn) return;

      let prices = { currentVariants: [], complementaryVariants: [] };
      try {
        if (pricesScript && pricesScript.textContent) {
          prices = JSON.parse(pricesScript.textContent);
        }
      } catch (e) {}

      function getCurrentVariantId() {
        const input = form.querySelector('input[name="id"]');
        return input ? input.value : null;
      }

      function getPriceForVariant(list, variantId) {
        var id = parseInt(variantId, 10);
        var found = list.find(function (v) { return v.id === id; });
        return found ? found.price : 0;
      }

      function getCurrentVariantData(variantId) {
        var id = parseInt(variantId, 10);
        return prices.currentVariants.find(function (v) { return v.id === id; }) || null;
      }

      function formatMoney(cents) {
        var format = (theme.settings && theme.settings.moneyWithCurrencyFormat) || '${{amount}}';
        var num = cents / 100;
        var amount = num.toFixed(2);
        var amountComma = amount.replace('.', ',');
        var amountNoDecimals = num.toFixed(0);
        return format
          .replace(/\{\{amount_with_comma_separator\}\}/g, amountComma)
          .replace(/\{\{amount\}\}/g, amount)
          .replace(/\{\{amount_no_decimals\}\}/g, amountNoDecimals);
      }

      function updateTotal() {
        var currentId = getCurrentVariantId();
        var compId = select.value;
        var currentPrice = getPriceForVariant(prices.currentVariants, currentId);
        var compPrice = getPriceForVariant(prices.complementaryVariants, compId);
        var total = (currentPrice || 0) + (compPrice || 0);
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (compPriceEl) {
          var span = compPriceEl.querySelector('.theme-money');
          if (span) span.textContent = formatMoney(compPrice);
        }
        if (currentSelect && currentId && currentSelect.value !== String(currentId)) {
          currentSelect.value = String(currentId);
        }
        var currentOpt = bundleEl.querySelector('[data-current-option]');
        var currentPr = bundleEl.querySelector('[data-current-price] .theme-money');
        if (currentId) {
          var vData = getCurrentVariantData(currentId);
          if (vData && currentOpt) currentOpt.textContent = vData.title || '—';
          if (vData && currentPr) currentPr.textContent = formatMoney(vData.price);
        }
      }

      function setMainProductVariant(variantId) {
        if (!variantId) return;
        var prevDisableReveal = window.__disableScrollToRevealElement;
        window.__disableScrollToRevealElement = true;

        // Prefer clicking the real option input so theme variant-picker updates UI/state properly.
        var picker = document.querySelector('variant-picker[data-section-id="' + sectionId + '"]');
        if (picker) {
          var input = picker.querySelector('[data-variant-id="' + variantId + '"]');
          if (input) {
            // Avoid click() (can scroll). Also tell variant-picker not to restore focus.
            input.checked = true;
            setTimeout(function () {
              window.__disableScrollToRevealElement = prevDisableReveal;
            }, 0);
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { noFocus: true } }));
            return;
          }
        }

        // Fallback: set hidden variant id input on form.
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = String(variantId);
          // Changing hidden id should not need focus; still ask listeners not to focus.
          idInput.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { noFocus: true } }));
          setTimeout(function () {
            window.__disableScrollToRevealElement = prevDisableReveal;
          }, 0);
          return;
        }

        // If we couldn't update anything, restore patched globals.
        setTimeout(function () {
          window.__disableScrollToRevealElement = prevDisableReveal;
        }, 0);
      }

      select.addEventListener('change', updateTotal);
      if (currentSelect) {
        currentSelect.addEventListener('change', function () {
          setMainProductVariant(currentSelect.value);
          setTimeout(updateTotal, 0);
        });
      }

      if (form) {
        form.addEventListener('change', function () {
          setTimeout(updateTotal, 0);
        });
      }

      btn.addEventListener('click', async function () {
        const currentVariantId = getCurrentVariantId();
        const compVariantId = select.value;
        if (!currentVariantId || !compVariantId) return;

        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('is-loading');

        const sectionsToUpdate = ['page-header', 'cart-drawer'].map(function (sel) { return document.querySelector(sel); }).filter(Boolean);
        const sectionIds = sectionsToUpdate.map(function (el) { return el.dataset.sectionId; });
        const sectionsParam = sectionIds.join(',');
        const sectionsUrl = window.location.pathname;

        function addItem(variantId) {
          const body = new FormData();
          body.append('id', variantId);
          body.append('quantity', 1);
          body.append('sections', sectionsParam);
          body.append('sections_url', sectionsUrl);
          return fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: body
          }).then(function (r) { return r.json(); });
        }

        try {
          const res1 = await addItem(currentVariantId);
          if (res1.status && res1.status !== 200) {
            throw new Error(res1.description || res1.message || 'Add to cart failed');
          }
          const res2 = await addItem(compVariantId);
          if (res2.status && res2.status !== 200) {
            throw new Error(res2.description || res2.message || 'Add to cart failed');
          }

          if (sectionsToUpdate.length && res2.sections && Object.keys(res2.sections).length >= sectionsToUpdate.length) {
            sectionsToUpdate.forEach(function (el) {
              if (el && el.updateFromCartChange && res2.sections[el.dataset.sectionId]) {
                el.updateFromCartChange(res2.sections[el.dataset.sectionId]);
              }
            });
          }
          bundleEl.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          if (theme.settings && theme.settings.afterAddToCart === 'drawer') {
            const drawer = document.querySelector('.js-cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open(btn);
          }
          btn.classList.add('is-success');
        } catch (err) {
          if (typeof console !== 'undefined') console.warn('Shop The Look add to cart:', err);
        }

        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
        setTimeout(function () { btn.classList.remove('is-success'); }, 2000);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
